import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useDispatch, useSelector } from 'react-redux'

import { api } from '@/lib/api-client'
import { MutationConfig } from '@/lib/react-query'
// @ts-expect-error Legacy JavaScript module has no type declarations.
import { fetchCustomers } from '../../Customers/customers.asynActions'
// @ts-expect-error Legacy JavaScript module has no type declarations.
import { selectFilters } from '../../Customers/customers.selectors'
// @ts-expect-error Legacy JavaScript module has no type declarations.
import { deleteRequestFromCache } from '../../../infrastructure/httpCache'

type UpdateStoreDelinquentInput = {
	accountId: string
	storeId: string
	isDelinquent: boolean
}

export const updateStoreDelinquent = ({ storeId, isDelinquent }: UpdateStoreDelinquentInput): Promise<void> => {
	return api.patch(`/stores/${storeId}/delinquent`, { isDelinquent })
}

type UseUpdateStoreDelinquentOptions = {
	mutationConfig?: MutationConfig<typeof updateStoreDelinquent>
}

type CustomerDispatch = (action: unknown) => unknown

// Cache keys are `${httpMethod}|${url}`; matches every cached customer list, whatever its filters.
const CUSTOMER_LIST_CACHE_PATTERN = /\|api\/customers(\?|$)/

export const refreshCustomersAfterStoreDelinquency = (
	dispatch: CustomerDispatch,
	filters: unknown,
) => {
	// Billing changes go through the react-query client, which doesn't clear the legacy doAsync cache.
	// Drop cached lists so switching filters afterwards can't show pre-change results.
	dispatch(deleteRequestFromCache({ patterns: [CUSTOMER_LIST_CACHE_PATTERN] }))
	return Promise.resolve(dispatch(fetchCustomers({
		filters,
		useCaching: false,
		noBusySpinner: true,
	})))
}

export const useUpdateStoreDelinquent = ({ mutationConfig }: UseUpdateStoreDelinquentOptions = {}) => {
	const queryClient = useQueryClient()
	const dispatch = useDispatch()
	const customerFilters = useSelector(selectFilters)
	const { onSuccess, ...restConfig } = mutationConfig || {}

	return useMutation({
		mutationFn: updateStoreDelinquent,
		onSuccess: async (...args) => {
			const variables = args[1]
			queryClient.invalidateQueries({
				queryKey: ['accounts', variables.accountId],
				exact: true,
				refetchType: 'active',
			})
			queryClient.invalidateQueries({
				queryKey: ['accounts', variables.accountId, 'stores'],
				refetchType: 'active',
			})
			await refreshCustomersAfterStoreDelinquency(dispatch, customerFilters)
			onSuccess?.(...args)
		},
		...restConfig,
	})
}
